// Activity feed list page (CHG-1643 / Wave 1 Tier 1).
//
// Org-scoped at /activity. Same backend endpoint (GET /api/v1/activity-feed)
// as PlatformActivityFeed below; differs only by scope= param.
//
// Spec: specs/tier-05-experience/activity-feed.cross-screen.yaml.

import { ListPage } from "../components/composition";
import {
  activityFeedListConfig,
  platformActivityFeedListConfig,
} from "../screens/activity-feed-list";

export function ActivityFeed() {
  return <ListPage config={activityFeedListConfig} />;
}

// Platform-scoped variant mounted at /platform/activity. Backend enforces
// platform-admin on scope=platform; FE pre-gate is on
// account.is_platform_admin in the route wiring (App.tsx).
export function PlatformActivityFeed() {
  return <ListPage config={platformActivityFeedListConfig} />;
}
